<template>
  <div v-loading="loading"
    style="width: 100%; height: 100%;"
    element-loading-text="正在跳转业财系统"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
  </div>
</template>

<script>
export default {
  name: 'logined',
  data() {
    return {
      loading: true
    }
  },
  created() {
    const code = this.$route.query.code
    if (!code) return
    this.toLogin(code)
  },
  methods: {
    toLogin(code) {
      this.$store.dispatch('Login', { code }).then(res => {
        if (res.code == 422) throw new Error(extract422Message(res.data));
        if (res.code != 0) throw new Error(res.message);
        setTimeout(() => {
          this.$router.push('/approval').catch(err => {
            console.log(err)
          })
        }, 1000)
      }).catch(err => {
        this.$message({
          message: err.response && err.response.data ? err.response.data.message : err.message,
          type: 'error',
          dangerouslyUseHTMLString: true
        });
      });
    }
  },
}
</script>